import { render, staticRenderFns } from "./form-sum.vue?vue&type=template&id=eb20c8a2"
import script from "./form-sum.vue?vue&type=script&lang=js"
export * from "./form-sum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports